<template>
  <v-sheet class="transparent-background-color">
    <div
      class="caption grey--text input-chip-group-label"
      :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
    >
      {{ $t("TableHeaders.cancel_flgs") }}
    </div>
    <v-chip-group v-model="model" column multiple>
      <v-chip
        v-for="stat in $consts.cancelFlgs"
        small
        label
        filter
        class="me-1"
        :color="stat.color"
        :text-color="stat.textColor"
        :key="stat.value"
        :value="stat.value"
        >{{ stat.text }}
      </v-chip>
    </v-chip-group>
  </v-sheet>
</template>

<script>
export default {
  name: "SearcherCancelFlgs",

  props: {
    value: Array,
    label: String,
  },

  data: () => ({
    model: [0],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
